import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["onClick", "disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "pagination-controls" }
const _hoisted_6 = { class: "per-page" }
const _hoisted_7 = { class: "per-page-select-wrapper" }

import { computed } from "vue";
import { Icon } from "@iconify/vue";
import Select from "@/components/ui/Select.vue";
import type { PaginationState } from "./types";

interface Props {
  pagination: PaginationState;
  onPageChange?: (page: number) => void;
  onPerPageChange?: (perPage: number) => void;
  perPageOptions?: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TablePagination',
  props: {
    pagination: {},
    onPageChange: {},
    onPerPageChange: {},
    perPageOptions: { default: () => [50, 100, 200] }
  },
  emits: ["update:currentPage", "update:perPage", "page-change", "per-page-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const page = computed(() => props.pagination.page);
const perPage = computed(() => props.pagination.perPage);
const total = computed(() => props.pagination.total);
const totalPages = computed(() => Math.ceil(total.value / perPage.value));

const visiblePages = computed(() => {
  const total = totalPages.value;
  const current = page.value;
  const pages: (number | string)[] = [];

  if (total <= 10) {
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    let startPage = Math.max(1, current - 5);
    let endPage = Math.min(total, current + 5);

    if (current <= 6) {
      startPage = 1;
      endPage = 10;
    } else if (current >= total - 5) {
      startPage = total - 9;
      endPage = total;
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < total) {
      pages.push("...");
    }
  }

  return pages;
});

const perPageOptions = computed(() =>
  props.perPageOptions.map((opt) => ({
    value: String(opt),
    label: String(opt),
  }))
);

const handlePrevPage = () => {
  if (page.value > 1) {
    const newPage = page.value - 1;
    emit("update:currentPage", newPage);
    emit("page-change", newPage);
    props.onPageChange?.(newPage);
  }
};

const handleNextPage = () => {
  if (page.value < totalPages.value) {
    const newPage = page.value + 1;
    emit("update:currentPage", newPage);
    emit("page-change", newPage);
    props.onPageChange?.(newPage);
  }
};

const changePage = (pageNum: number | string) => {
  if (pageNum === "..." || pageNum === page.value) return;
  const pageNumber = pageNum as number;
  emit("update:currentPage", pageNumber);
  emit("page-change", pageNumber);
  props.onPageChange?.(pageNumber);
};

const handlePerPageChange = (newPerPage: string | number) => {
  const perPageValue = Number(newPerPage);
  emit("update:perPage", perPageValue);
  emit("update:currentPage", 1);
  emit("per-page-change", perPageValue);
  props.onPerPageChange?.(perPageValue);
  props.onPageChange?.(1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["custom-pagination", { 'tight-spacing': totalPages.value <= 10 }])
    }, [
      _createElementVNode("button", {
        onClick: handlePrevPage,
        class: "control-prev",
        disabled: page.value <= 1,
        "aria-label": "Previous page"
      }, [
        _createVNode(_unref(Icon), {
          icon: "mdi:chevron-left",
          width: "16",
          height: "16",
          style: {"margin-right":"6px"}
        }),
        _cache[0] || (_cache[0] = _createTextVNode(" Prev ", -1))
      ], 8, _hoisted_2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (pageNum) => {
        return (_openBlock(), _createElementBlock("button", {
          key: pageNum,
          class: _normalizeClass([{ active: page.value === pageNum }, pageNum === '...' ? 'ellipsis' : '']),
          onClick: ($event: any) => (changePage(pageNum)),
          disabled: pageNum === '...'
        }, _toDisplayString(pageNum), 11, _hoisted_3))
      }), 128)),
      _createElementVNode("button", {
        onClick: handleNextPage,
        class: "control-next",
        disabled: page.value >= totalPages.value,
        "aria-label": "Next page"
      }, [
        _cache[1] || (_cache[1] = _createTextVNode(" Next ", -1)),
        _createVNode(_unref(Icon), {
          icon: "mdi:chevron-right",
          width: "16",
          height: "16",
          style: {"margin-left":"6px"}
        })
      ], 8, _hoisted_4)
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Select, {
            "model-value": perPage.value.toString(),
            options: perPageOptions.value,
            size: "sm",
            "onUpdate:modelValue": handlePerPageChange
          }, null, 8, ["model-value", "options"])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "per-page-label" }, "per page", -1))
      ])
    ])
  ]))
}
}

})